<template>
    <div class="login-wrapper flex flex-direction ">
        <header-modular :cancel="false"></header-modular>
        <div class="login-container flex-sub flex flex-direction">
            <div class="container flex-sub flex flex-direction align-end justify-center">
                <div class="login-form">
                    <div class="classify-container">
                        <div :class="{active:type === 0}" class="classify" @click="type = 0">帐号登录</div>
<!--                        <div :class="{active:type === 1}" class="classify" @click="type = 1">快捷登录</div>-->
                    </div>
                    <el-form ref="ruleForm" :model="ruleForm"
                             :rules="rules" class="login margin-top-xl" v-if="type === 0">
                        <el-form-item ref="account" prop="account">
                            <el-input v-model="ruleForm.account" class="input-container" placeholder="请输入账号">
                                <i slot="prefix" class="iconfont icon-phone"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item ref="phone" prop="password">
                            <el-input v-model="ruleForm.password" class="input-container" placeholder="请输入密码" type="password" show-password>
                                <i slot="prefix" class="iconfont icon-password"></i>
                            </el-input>
                        </el-form-item>
                        <el-button :loading="loading" class="submit text-df text-white margin-top-xs"
                                   type="primary" @click="submitForm('ruleForm')">登录
                        </el-button>
                    </el-form>
                    <el-form ref="ruleForm" :model="ruleForm"
                             :rules="rules" class="login margin-top-xl" v-else>
                        <el-form-item ref="phone" prop="phone">
                            <el-input v-model="ruleForm.phone" class="input-container" placeholder="请输入手机号" maxlength="11">
                                <i slot="prefix" class="iconfont icon-phone"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item ref="code" prop="code">
                            <el-input v-model="ruleForm.code" class="input-container" placeholder="请输入验证码">
                                <i slot="prefix" class="iconfont icon-password"></i>
                                <el-button slot="suffix"  :disabled="typeof codeText === 'number'" :loading="sending" class="text-white text-xs"
                                           type="text" @click="submitSMS">
                                    {{ codeText }} <span v-if="typeof codeText === 'number'">s后重新发送</span>
                                </el-button>
                            </el-input>
                        </el-form-item>
                        <el-button :loading="loading" class="submit text-df text-white margin-top-xs"
                                   type="primary" @click="submitForm('ruleForm')">登录
                        </el-button>
                    </el-form>
                    <div class="login-icons margin-top-sm">
                        <div class="login-icon-t">
                            <i class="left"></i>
                            <span>使用其他方式登录</span>
                            <i class="right"></i>
                        </div>
                        <div class="login-img">
                            <a :href="wxOauth2Url" class="login-icon-wx"><i class="iconfont icon-wx"></i></a>
                        </div>
                        <div class="text-white text-center margin-top-xs">微信登录</div>
                    </div>
                </div>
            </div>
        </div>
        <footer-link-modular></footer-link-modular>
    </div>
</template>

<script>

import {login, sendPhoneCode, sms_login} from '@/api/login'
import {TOAST, toast, wxOauth2Url} from "@/utils/utils";
import HeaderModular from "@/views/web/components/HeaderModular";
import FooterLinkModular from "@/views/web/components/FooterLinkModular";
import rules from "@/utils/rules";

export default {
    name: 'login',
    data() {
        return {
            type:0,
            ruleForm: {
                account: '',
                password: '',
                phone: '',
                code: '',
            },
            rules: {
                account: [
                    {required: true, message: '请输入账号', trigger: 'blur'},
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: '请输入手机号', trigger: 'change'},
                    rules.phone
                ],
                code: [
                    {required: true, message: '请输入验证码', trigger: 'change'},
                ],
            },
            loading: false,
            codeText: '获取验证码', // 验证码文字
            id: null, // 计时器id
            timeId: null, // 一次性计时器id
            sending: false,
            wxOauth2Url:wxOauth2Url()
        }
    },
    components: {FooterLinkModular, HeaderModular},
    created() {
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.login();
                }
            });
        },
        async login() {
            this.loading = true
            let _data = this.type === 0 ? await login(this.ruleForm.account, this.ruleForm.password)
                : await sms_login(this.ruleForm.phone,this.ruleForm.code)
            this.loading = false
            if (_data.status === 200) {
                await window.localStorage.setItem('user', JSON.stringify(_data.data))
                await window.localStorage.setItem('token', JSON.stringify(_data.data.mid))
                await window.localStorage.setItem('emofUserTokenSafer', JSON.stringify(_data.data.midToken))
                this.$store.state.token = _data.data.mid
                this.$store.state.emofUserTokenSafer = _data.data.midToken
                this.$store.state.user = _data.data
                this.$router.replace('/web/admin/member')
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        submitSMS() {
            this.$refs.ruleForm.validateField('phone', (valid) => {
                if (!valid) {
                    this.sendCode()
                }
            })
        },
        async sendCode() {
            if (this.codeText === '获取验证码' || this.codeText === '重新发送') {
                this.sending = true
                let _data =  await sendPhoneCode(this.ruleForm.phone)
                this.sending = false
                if (_data.status === 1) {
                    let codeNum = 60
                    this.codeText = codeNum
                    this.id = setInterval(() => {
                        if (codeNum === 0) {
                            this.codeText = '重新发送'
                            clearInterval(this.id)
                            return
                        }
                        if (typeof codeNum === 'number') {
                            codeNum--
                            this.codeText = codeNum
                        }
                    }, 1000)
                } else {
                    toast(_data.msg, TOAST.error)
                    this.codeText = '重新发送'
                    clearInterval(this.id)
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.login-wrapper {
    min-height: 100vh;

    .login-container {
        width: 100%;
        background-size: 100% auto;
        background: #ffffff url(../../assets/img/bg_login.jpg) no-repeat center;

        .container {
            width: 1200px;
            margin: 0 auto;

            .login-form {
                display: flex;
                flex-direction: column;
                width: 400px;
                height: 500px;
                background-color: var(--blue);
                border-radius: 10px;
                position: relative;
                padding: 45px;
                z-index: 1;

                .classify-container{
                    display: flex;
                    margin-top: 15px;
                    position: relative;

                    &:before {
                        position: absolute;
                        width: 308px;
                        height: 1px;
                        background-color: #ffffff;
                        opacity: 0.4;
                        content: '';
                        bottom: -15px;
                        left: 0;
                    }

                    //&:after {
                    //    position: absolute;
                    //    width: 1px;
                    //    height: 21px;
                    //    background-color: #ffffff;
                    //    opacity: 0.4;
                    //    content: '';
                    //    top: 50%;
                    //    left: 50%;
                    //    transform: translate(-50%, -50%);
                    //}

                    .classify {
                        font-size: 18px;
                        text-align: center;
                        flex: 1;
                        color: #ffffff44;
                        cursor: pointer;

                        &.active {
                            color: #ffffff;
                            position: relative;

                            &:before {
                                position: absolute;
                                width: 76px;
                                height: 2px;
                                background-color: #ffffff;
                                content: '';
                                bottom: -15px;
                                left: 50%;
                                transform: translateX(-50%);
                            }
                        }
                    }
                }

                &:after {
                    position: absolute;
                    width: 561px;
                    height: 357px;
                    background: rgba(10, 34, 64, .1);
                    border-radius: 10px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    content: '';
                    z-index: -1;
                }

                &:before {
                    position: absolute;
                    width: 489px;
                    height: 450px;
                    margin: 0 auto;
                    background: rgba(10, 34, 64, .3);
                    border-radius: 10px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    content: '';
                    z-index: -1;
                }

                .input-container {
                    height: 50px;
                }

                .submit {
                    width: 100%;
                    height: 46px;
                    background-image: var(--gradualOrange);
                    background-blend-mode: normal,
                    normal;
                    border-radius: 10px;
                    border: none;
                }
            }
        }

        .login-icons {
            .login-icon-t {
                font-size: 12px;
                color: #999;
                height: 36px;
                text-align: center;
                line-height: 36px;
                margin-bottom: 10px;

                .left {
                    width: 100px;
                    border-bottom: 1px solid rgba(255, 255, 255, .4);
                    float: left;
                    margin-top: 18px;
                }

                .right {
                    width: 100px;
                    border-bottom: 1px solid rgba(255, 255, 255, .4);
                    float: right;
                    margin-top: 18px;
                }
            }
            .login-img {
                width: 45px;
                margin: 0 auto;

                a.login-icon-wx {
                    display: inline-block;
                    width: 45px;
                    height: 45px;
                    background: #fff;
                    border-radius: 100%;
                    text-align: center;
                    line-height: 45px;

                    i {
                        font-size: 30px;
                        color: #0a2240;
                    }
                }
            }
        }
    }
}
</style>


